export default {
  "FileInput": "_FileInput_1ipp2_1",
  "FileInputPreviews": "_FileInputPreviews_1ipp2_9",
  "FileInputButton": "_FileInputButton_1ipp2_14",
  "FileInputPreview": "_FileInputPreview_1ipp2_9",
  "FileInputControl": "_FileInputControl_1ipp2_44"
};import "ni:sha-256;fbXJ6Nhp5zM0_P6pF6YysPCfskWu_mgw9BkQBYym9Jw";